var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v("Html Sending email example code In Contact Us Form")]),_c('HtmlGist')],1)}
var staticRenderFns = []

export { render, staticRenderFns }